import { SINGLE_AUDIT_SUCCESS_TYPES } from 'modules/audits/actionTypes';
import type { Action } from 'modules/global/generic.types';

import type { PaginatedAuditEvent } from '../../types/projections/paginated-audit-event';

export type AuditWithEvents = {
  id: string;
  events: PaginatedAuditEvent[];
};

export const isAuditWithEvents = ({ type, payload }: Action<unknown>): boolean =>
  SINGLE_AUDIT_SUCCESS_TYPES.includes(type) &&
  Array.isArray((payload as AuditWithEvents | undefined)?.events) &&
  Boolean((payload as AuditWithEvents | undefined)?.id);
